import React from 'react';
import PropTypes from 'prop-types';
import Price from 'brastrap/promotional/price/Price';
import StyledText, {
  getWrappingTag,
} from 'brastrap/editorial/styled-text/StyledText';
import Link from '../../common/link/Link';
import Carousel from '../../common/carousel/Carousel';
import Rating from '../../common/rating/Rating';

const STYLE_PREFIX = 'c-recommendations-rail';

const ConstructorRecommendationsRail = props => {
  const {
    constructorProductRecommendations,
    currency,
    isMobile,
    title,
    locale,
  } = props;
  const carouselOptions = {
    labels: {
      next: {
        heading: '',
      },
      prev: {
        heading: '',
      },
    },
    responsive: [],
    slidesToShow: isMobile
      ? Number(constructorProductRecommendations?.slidesToShow?.mobile)
      : Number(constructorProductRecommendations?.slidesToShow?.desktop),
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
  };
  let TagName;
  if (Array.isArray(title)) {
    TagName = getWrappingTag(title || [], 'h2');
  }

  const headerClass = `${STYLE_PREFIX}__header ${
    constructorProductRecommendations.centreTitle
      ? `${STYLE_PREFIX}__header-central`
      : ''
  }`;

  return (
    <>
      {title && title.length && Array.isArray(title) && (
        <header className={headerClass}>
          <TagName>
            {title.map(item => (
              <StyledText key={item.id} {...item} />
            ))}
          </TagName>
        </header>
      )}
      {title && typeof title === 'string' && (
        <h2 className={`${STYLE_PREFIX}__header`}>{title}</h2>
      )}
      <div
        className={`${STYLE_PREFIX}__container`}
        data-cnstrc-recommendations
        data-cnstrc-recommendations-pod-id={
          constructorProductRecommendations.podId
        }
        data-cnstrc-result-id={
          constructorProductRecommendations.requestResultId
        }
        data-cnstrc-num-results={
          constructorProductRecommendations.numberOfRequestedItems
        }
        data-cnstrc-recommendations-seed-items={
          constructorProductRecommendations.recommendedSeedItem == null
            ? undefined
            : [constructorProductRecommendations.recommendedSeedItem]
        }
      >
        {constructorProductRecommendations.recommendedItems.length > 0 && (
          <Carousel {...carouselOptions}>
            {constructorProductRecommendations.recommendedItems.map(
              (recommendedItem, index) => {
                const visibleSlide = carouselOptions.slidesToShow
                  ? carouselOptions.slidesToShow
                  : 0;
                return (
                  <Link
                    href={
                      locale === 'en-GB'
                        ? recommendedItem.data.url
                        : `/us${recommendedItem.data.url}`
                    }
                    key={recommendedItem.data.id}
                    data-cnstrc-btn="read"
                  >
                    <div
                      className={`${STYLE_PREFIX}__productCard ${STYLE_PREFIX}__productCard-carousel`}
                      data-cnstrc-item="recommendation"
                      data-cnstrc-item-id={recommendedItem.data.id}
                      data-cnstrc-item-name={recommendedItem.data.styleName}
                      data-cnstrc-item-variation-id={
                        recommendedItem.data.variation_id
                      }
                      data-cnstrc-strategy-id={recommendedItem.strategy.id}
                    >
                      <img
                        src={recommendedItem.data.image_url}
                        alt={recommendedItem.value}
                        fetchPriority={index < visibleSlide ? 'high' : 'auto'}
                        className={`${STYLE_PREFIX}__recommendationsProductImage`}
                      />
                      <p
                        className={`${STYLE_PREFIX}__recommendationsProductCode c-product-summary__code`}
                      >
                        {recommendedItem.data.id}
                      </p>
                      <h3
                        className={`${STYLE_PREFIX}__recommendationsProductTitle ${STYLE_PREFIX}__recommendationsProductTitle-carousel`}
                      >
                        {`${recommendedItem.data.brand} ${recommendedItem.data.styleName}`}
                      </h3>
                      <div
                        className={`${STYLE_PREFIX}__recommendationsCarouselPrice`}
                      >
                        <Price
                          price={recommendedItem.data.price}
                          currency={currency}
                          originalPrice={recommendedItem.data.originalPrice}
                          onSale={recommendedItem.data.on_sale}
                        />
                      </div>
                      <div
                        className={`${STYLE_PREFIX}__recommendationsCarouselSizeRange`}
                      >
                        <p className="c-product-summary__sizes">
                          {recommendedItem.data?.sizeRange}
                        </p>
                      </div>
                      <div
                        className={`${STYLE_PREFIX}__recommendationsCarouselRating`}
                      >
                        {recommendedItem.data.ratingTotal > 0 && (
                          <Rating
                            total={recommendedItem.data.ratingTotal}
                            value={recommendedItem.data.rating}
                            hideRatingTotalString={false}
                          />
                        )}
                      </div>
                    </div>
                  </Link>
                );
              }
            )}
          </Carousel>
        )}
      </div>
    </>
  );
};

ConstructorRecommendationsRail.propTypes = {
  constructorProductRecommendations: PropTypes.object,
  currency: PropTypes.string,
  isMobile: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  locale: PropTypes.string,
};

export default ConstructorRecommendationsRail;
